module.exports = __webpack_public_path__ + "img/beer_id-51.275021de.png";